import React from 'react';
import { Link } from 'react-router-dom';
import { isFreeSearcher } from 'v2/utils/permissions';
import { RootState } from 'v2/models';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import styles from './subscribeButton.module.scss';

interface SubscribeButtonProps {
  expanded: boolean;
}

const SubscribeButton = ({ expanded }: SubscribeButtonProps) => {
  const user = useSelector((state: RootState) => state.user.user);
  const permissions = useSelector(
    (state: RootState) => state.permissions.permissions
  );

  const userIsFreeSearcher = isFreeSearcher(permissions);

  return (
    <>
      {userIsFreeSearcher && !user.waitlisted && (
        <Link
          data-testid="subscribeToConnectButton"
          to={'/settings/subscription'}
          className={classnames(
            'btn',
            { 'btn-primary px-3 mb-2': expanded },
            { 'btn-outline-primary mr-4': !expanded },
            { [styles.subscribeButton]: !expanded }
          )}
        >
          Subscribe
        </Link>
      )}
    </>
  );
};

export default SubscribeButton;
